import { Component, Input } from '@angular/core';

@Component({
    selector: 'activity-row-accepted-bank-statement-terms',
    template: `
        <span><div style="float: left; margin-right: 10px; transform: translate(0px, -5px);"><mat-icon>{{ activityIcon }}</mat-icon></div>
        <div class="description"><strong>Accepted Bank Statement Terms</strong></div></span>
    `,
    standalone: false
})
export class ActivityRowAcceptedBankStatementTermsComponent {
    @Input() activity;
    activityIcon = 'account_balance';
}
